import style from "../../../styles/pages/oraculo/oraculo.module.scss";
import { Button } from "../../components/Button";

export const ProgressModal = ({ onCancelExecution }) => {
  return (
    <div className={style.executeInProgress}>
      <div className="d-flex flex-column align-center flex-1 justify-center">
        <img src="/assets/img/LoadingOracle.png" alt="" />
        <span className={style.loader} />
        <p>Executando...</p>
        <span>
          Estamos executando a sua filtragem, isso deve levar alguns segundos...
        </span>
      </div>
      <Button design="underline" className="mb-30" onClick={onCancelExecution}>
        CANCELAR
      </Button>
    </div>
  );
};
